exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".process[data-v-316356b5] {\n  max-height: 40%;\n  overflow: auto;\n}\n.title-box[data-v-316356b5] {\n  margin: 0 0 20px 20px;\n  font-size: 18px;\n  font-weight: 500;\n  position: relative;\n}\n.title-box[data-v-316356b5]::before {\n  content: \" \";\n  background-color: #409eff;\n  width: 4px;\n  height: 100%;\n  border-radius: 1px;\n  position: absolute;\n  left: -10px;\n}\n.bottom-box[data-v-316356b5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}", ""]);

// exports
